<div class="wizard-check-to-close-modal">
  <h6>
    {{ "are_you_sure_you_want_to_close_with_unsaved_work_wizard_lingo" | translation }}
  </h6>
  <div class="wizard-check-to-close-modal-button-container">
    <button nbButton ghost (click)="closeModal(false)">
      {{ "cancel" | translation }}
    </button>
    <button nbButton status="primary" (click)="closeModal(true)">
      {{ "yes" | translation }}
    </button>
  </div>
</div>
